import styled from "styled-components";
import { theme } from "../../../config";

const Wrapper = styled.div`
  background: ${theme.colors.white};
  padding: 25px;
  box-shadow: 0px 0px 4px rgba(176, 139, 0, 0.1);
  border-radius: 8px;
  height: 100%;
  width: 100%;
`;

const InsightsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const DropdownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex: 1;
  font-size: 16px;
  color: #273049;
  font-family: "Orkney Bold";
`;

const DetailsWrapper = styled.div`
  flex-direction: row;
  display: flex;
  height: 100%;
`;

const RightDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 25%;
`;

const LeftDetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  padding-top: 1em;
  padding-bottom: 1em;
`;

const MarkerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1.3em;

  @media (max-width: 1400px) {
    margin-left: 7%;
  }
  @media (max-width: 1300px) {
    margin-left: 5%;
    gap: 0.5em;
  }
  @media (max-width: 1200px) {
    gap: 0;
    margin-left: 20%;
  }
  @media (max-width: 1075px) {
    margin-left: 22%;
  }
  @media (max-width: 1025px) {
    gap: 1.3em;
    margin-left: 0;
  }

  @media (max-width: 900px) {
    margin-left: 30px;
  }

  @media (max-width: 800px) {
    gap: 0;
  }

  @media (min-width: 1025px) and (max-width: 1075px) {
    margin-right: -25px;
    flex-wrap: nowrap;
  }
`;

const ButtonMarkerItem = styled.button`
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 12px;
  color: ${theme.colors.custom.darkblue4};
  font-weight: 500;
  text-decoration: underline;
`;

const MarkerItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  margin-right: 2.5em;
  align-items: center;

  @media (max-width: 1300px) {
    margin-right: 10px;
  }
  @media (max-width: 1100px) {
    margin-right: 0;
  }
`;

const MarkerTitle = styled.div`
  font-size: 12px;
  color: #111111;
  font-weight: 500;
`;

const Marker = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  border-radius: 2px;
  height: 12px;
  width: 12px;
`;

export {
  Wrapper,
  InsightsWrapper,
  DropdownWrapper,
  Header,
  TitleWrapper,
  DetailsWrapper,
  RightDetailsWrapper,
  LeftDetailsWrapper,
  Marker,
  MarkerItem,
  MarkerWrapper,
  MarkerTitle,
  ButtonMarkerItem,
};
